import { withTheme } from '@material-ui/styles'
import { makeStyles } from '@material-ui/styles'

import LinearProgress from '@material-ui/core/LinearProgress'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles({
    root: {
        backgroundColor: (props) => props.backgroundColor || '#e0e0e0', // Colore sfondo/traccia
    },
    bar: {
        backgroundColor: (props) => props.color || '#4caf50', // Colore della BARRA dinamica
    },
})
const LoaderSingleComponent = ({theme, width = 20, height = 4, layout = 'linear', color = 'primary'}) => {
    let _color = ''
    let _backgroundColor = ''
    switch(color) {
        case "error":
            _color = theme.palette.error.main
            _backgroundColor = theme.palette.error[200]
        break
        case "warning":
            _color = theme.palette.warning.main
            _backgroundColor = theme.palette.warning[200]
        break
        case "info":
            _color = theme.palette.info.main
            _backgroundColor = theme.palette.info[200]
        break
        case "success":
            _color = theme.palette.success.main
            _backgroundColor = theme.palette.success[200]
        break
        default:
            //silence is golden
        break
    }
    const classes = (!_color || !_backgroundColor) 
        ? {}
        : useStyles({ color: _color, backgroundColor: _backgroundColor })

    switch (layout) {
        case 'circular':
            return (
                <CircularProgress 
                    style={{ width: width, height: width, color: _color }} 
                />
            )
        case 'linear':
        default:
            return (
                <LinearProgress 
                    classes={{
                        root: classes.root,
                        bar: classes.bar,
                    }} 
                    style={{ width: width, height: height }} 
                />
            )
    }
}

export default withTheme(LoaderSingleComponent)